import {mapActions, mapGetters} from 'vuex'

import {map, assoc} from 'ramda'

export const creativeMixin = {
  computed: {
    ...mapGetters({
      'creatives': 'creatives/all',
      'creative': 'creatives/creative',
      'creativeUnits': 'creatives/creativeUnits',
      'creativeUnitsPager': 'creatives/creativeUnitsPager',
      'creativeUnitsSorting': 'creatives/creativeUnitsSorting',
      'creativeUnitsSearchTerms': 'creatives/creativeUnitsSearchTerms',
      'creativeUnitBulkEditMode': 'creatives/creativeUnitBulkEditMode'
    })
  },
  methods: {
    ...mapActions({
      'addCreative': 'creatives/addCreative',
      'getCreatives': 'creatives/getCreatives',
      'deleteCreative': 'creatives/deleteCreative',
      'updateCreative': 'creatives/updateCreative',
      'editCreativeName': 'creatives/editCreativeName',
      'getCreativeUnits': 'creatives/getCreativeUnits',
      'getCreativeUnit': 'creatives/getCreativeUnit',
      'updateCreativeUnit': 'creatives/updateCreativeUnit',
      'updateSingleCreativeUnit': 'creatives/updateSingleCreativeUnit',
      'updateBulkCreative': 'creatives/updateBulkCreative',
      'uploadCsv': 'creatives/uploadCsv',
      'cloneCreative': 'creatives/cloneCreative',
      'assetCopyToCreative': 'creatives/assetCopyToCreative',
      'setCreativeUnitsPagerData': 'creatives/setCreativeUnitsPagerData',
      'setCreativeUnitsSortingData': 'creatives/setCreativeUnitsSortingData',
      'setCreativeUnitsSearchTerms': 'creatives/setCreativeUnitsSearchTerms',
      'setCreativeUnitBulkEditMode': 'creatives/setCreativeUnitBulkEditMode',
      'getReviewLinkHistory': 'creatives/getReviewLinkHistory'
    }),
    updateCheckboxData (toggle) {
      this.creative.fields = map(item => assoc('is_editable', toggle, item), this.creative.fields)
    },
    currencyIcon (type) {
      if (type === 'gbp') {
        return '&pound;'
      }
      if (type === 'usd') {
        return '&dollar;'
      }
      if (type === 'eur') {
        return '&euro;'
      }
    },
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/creativeMixin.js